module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-03.ea0f495e.jpg";